// TODO: only use the Glide Modules we need
import Glide from "@glidejs/glide/entry/entry-complete";


export default {
    initSlider() {
        new Glide('.js-hero-slider',{
            type: 'slider',
            // autoplay: 3000,
        } ).mount();
    }
}
